export default function isFigureChartModel(model) {
  return model.setFigure !== undefined;
}
//# sourceMappingURL=isFigureChartModel.js.map